// extracted by mini-css-extract-plugin
export default {"icon":"Chat_icon__01fD+","buttonsContainer":"Chat_buttonsContainer__SPHgA","button":"Chat_button__86YqN"};